import { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

import SelectOnPath from '../../image/SelectOn2.png';
import SelectOffPath from '../../image/SelectOff2.png';

const LANGUAGE_OPTIONS = [
  { name: 'ko', label: '한국어' },
  { name: 'en', label: 'English' },
];

const WIDTH = 120;

export default function LanguageSelectBox(props) {
  const { value, onChange } = props;

  const currentOption = LANGUAGE_OPTIONS.find(opt => opt.name === value) || LANGUAGE_OPTIONS[0];

  const [isClicked, setIsClicked] = useState(false);

  const TopLevelRef = useRef();
  const SelectRef = useRef();
  const OptionRef = useRef([]);
  const OptionTextRef = useRef([]);

  // 외부 클릭 시 드롭다운 닫기 //
  useEffect(() => {
    document.addEventListener('mousedown', onClickOutSide);
    return () => document.removeEventListener('mousedown', onClickOutSide);
  }, []);

  function onClickOutSide(e) {
    if (TopLevelRef.current !== e.target && !TopLevelRef.current.contains(e.target)) {
      SelectRef.current.style.border = '1px solid #CBCBCB';
      SelectRef.current.style.height = '32px';
      SelectRef.current.style.overflow = 'hidden';
      setTimeout(() => setIsClicked(false), 150);
    }
  }

  // 옵션 호버링 시작 //
  function onMouseOver(index) {
    OptionRef.current[index] && (OptionRef.current[index].style.backgroundColor = '#FF8B48');
    OptionTextRef.current[index] && (OptionTextRef.current[index].style.color = '#FFFFFF');
  }

  // 옵션 호버링 끝 //
  function onMouseLeave(index) {
    OptionRef.current[index] && (OptionRef.current[index].style.backgroundColor = '#FFFFFF');
    OptionTextRef.current[index] && (OptionTextRef.current[index].style.color = '#000000');
  }

  // 선택박스 클릭시 //
  function onClick() {
    if (isClicked) {
      SelectRef.current.style.border = '1px solid #CBCBCB';
      SelectRef.current.style.height = '32px';
      SelectRef.current.style.overflow = 'hidden';
      setTimeout(() => setIsClicked(false), 150);
    }
    else {
      SelectRef.current.style.border = '1px solid #FF8B48';
      SelectRef.current.style.height = `${32 * (LANGUAGE_OPTIONS.length + 1)}px`;
      SelectRef.current.style.overflowY = 'scroll';
      SelectRef.current.style.overflowX = 'none';
      setIsClicked(true);
    }
  }

  // 옵션 클릭시 //
  function onClickOption(index) {
    onChange(LANGUAGE_OPTIONS[index].name);
  }

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      <SelectBox
        ref={SelectRef}
        onClick={onClick}>
        <SelectedViewWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='pointer'>
            {currentOption.label}
          </Text>
          <ArrowImageWrapper>
            <ArrowImage src={SelectOnPath} opacity={isClicked ? 1 : 0} />
            <ArrowImage src={SelectOffPath} opacity={isClicked ? 0 : 1} />
          </ArrowImageWrapper>
        </SelectedViewWrapper>
        {
          isClicked &&
          LANGUAGE_OPTIONS.map((data, index) => (
            <OptionWrapper
              key={'LanguageOption-' + index}
              ref={(element) => OptionRef.current[index] = element}
              onMouseOver={() => onMouseOver(index)}
              onMouseLeave={() => onMouseLeave(index)}
              onClick={() => onClickOption(index)}>
              <Text
                ref={(element) => OptionTextRef.current[index] = element}
                fontFamily='NotoSansKR-Regular'
                fontSize={14}
                color='#000000'
                cursor='pointer'>
                {data.label}
              </Text>
            </OptionWrapper>
          ))
        }
      </SelectBox>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: ${WIDTH}px;
  height: 32px;
`;

const SelectBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${WIDTH}px;
  height: 32px;

  border-radius: 8px;
  overflow: hidden;

  border: 1px solid #CBCBCB;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 1);

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }

  &::-webkit-scrollbar {
    width: 0px;
  }

  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px #FF8B48;
    border: 3px solid transparent;
    height: 25px;
    border-radius: 200px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
    border: 4px solid transparent;
    background-color: transparent;
  }

  &::-webkit-scrollbar-track-piece {
    background-color: transparent;
  }
`;

const SelectedViewWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 3px 8px;

  width: calc(${WIDTH}px - 17px);

  border-bottom: 1px solid #B2B2B2;
`;

const ArrowImageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: 7px 0px;

  width: 16px;
  height: 10px;
`;

const ArrowImage = styled.img`
  position: absolute;

  width: 100%;
  height: 100%;

  opacity: ${props => props.opacity};

  transition: all 0.3s ease-in-out;
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 6px 8px;

  width: calc(100% - 17px);

  border-bottom: 1px solid #B2B2B2;

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0px;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
